import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'apc-admin-crud-action-buttons',
  templateUrl: './admin-crud-buttons.component.html',
  styleUrls: ['../action-buttons.component.scss', './admin-crud-buttons.component.scss'],
})
export class AdminCrudButtonsComponent {
  @Output() editEvent = new EventEmitter<boolean>(false);
  @Output() saveEvent = new EventEmitter<boolean>(false);
  @Output() cancelEvent = new EventEmitter<boolean>(false);
  @Output() preDeleteEvent = new EventEmitter<boolean>(false);
  @Output() deleteEvent = new EventEmitter<boolean>(false);
  @Output() addNewFormEvent = new EventEmitter<boolean>(false);
  @Output() downloadEvent = new EventEmitter<boolean>(false);
  @Input() public hideDelete: boolean = false;
  @Input() public edit: boolean = false;
  @Input() public isSave: boolean = false;
  public predelete: boolean = false;
  @Input() form: any;

  // permissions 
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() context: string;

  editForm(e?: any) {
    this.edit = !this.edit;
    setTimeout(() => {
      e && window.scrollTo({ top: (e.layerY - 115), behavior: 'smooth' });
    }, 100);
    this.editEvent.emit(this.edit);
  }

  addNewForm() {
    this.addNewFormEvent.emit(true);
  }

  saveForm() {
    this.saveEvent.emit(true);
  }

  cancelForm() {
    this.cancelEvent.emit(true);
    this.editForm();
  }

  preDelete() {
    this.predelete = !this.predelete;
    this.preDeleteEvent.emit(this.predelete);
  }

  delete() {
    this.deleteEvent.emit(true);
    this.preDeleteEvent.emit(false);
  }

  dissmisModal() {
    this.preDeleteEvent.emit(false);
  }

  download() {
    this.downloadEvent.emit(true);
  }
}
